<template>
  <fragment>
    <div class="col-12 col-lg-7">
      <div class="dash-section contains-list">
        <div class="header mb-2">
          <div>
            <h2 id="studentsListTitle" class="title">
              {{ totalStudents }} Registered Users
            </h2>
          </div>
          <div class="actions section-header-offset">
            <button
              v-if="canBulkUpload"
              class="dash-button"
              @click="handleUpload"
            >
              Bulk Upload Allowances
            </button>
            <button class="dash-button" @click="handleInvite">Invite</button>
          </div>
        </div>
        <div class="dash-sub-section mt-0">
          <student-list-header />
          <students-list :has-next-page="hasNext" :loading="isLoading" />
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-5">
      <custom-user-tags-section
        v-if="customUserTags.hasTags()"
        :value="registrationsReport.parameters.customCampusTags"
        @input="setCustomTags"
      />
      <registrations-over-time-section />
      <mental-health-concerns-section />
      <demographics-section />
    </div>
  </fragment>
</template>

<script>
import InviteStudentModal from './Students/InviteStudentModal.vue';
import DemographicsSection from './Students/DemographicsSection.vue';
import MentalHealthConcernsSection from './Students/MentalHealthConcernsSection.vue';
import RegistrationsOverTimeSection from './Students/RegistrationsOverTimeSection.vue';
import StudentsList from './Students/StudentsList.vue';
import StudentListHeader from './Students/StudentListHeader.vue'
import UploadAllowances from './Students/UploadAllowances/UploadAllowances.vue'
import CustomUserTagsSection from './Students/CustomUserTagsSection.vue';

export default {
  name: 'StudentsTab',

  components: {
    DemographicsSection,
    MentalHealthConcernsSection,
    RegistrationsOverTimeSection,
    StudentsList,
    StudentListHeader,
    CustomUserTagsSection
  },

  inject: ['studentDetailsReport','registrationsReport','demographicsReport','customUserTags'],

  data() {
    return {
      canBulkUpload: false,
    }
  },

  computed: {
    isLoading() {
      return this.studentDetailsReport.loading;
    },
    hasNext() {
      return this.studentDetailsReport.hasNext;
    },
    totalStudents() {
      return this.studentDetailsReport.data.activeStudents;
    }
  },

  async mounted() {
    this.canBulkUpload = this.$store.getters.currentUser.isAdmin
      || await this.$globals.hasFeature('can-bulk-upload');
  },

  methods: {
    handleInvite() {
      this.$modal.show(InviteStudentModal);
    },
    handleUpload() {
      this.$modal.show(UploadAllowances, {
        props: {
          schoolId: this.studentDetailsReport.schoolId
        }
      })
    },
    setCustomTags(tagsList) {
      this.registrationsReport.setParameters({ customCampusTags: tagsList });
      this.demographicsReport.withCustomTags(tagsList);
    }
  }
};
</script>

<style lang="scss" scoped>
.dash-section.no-min-size {
  margin-bottom: 2rem;
  min-height: 0px;
}
.dash-section {
  margin-bottom: 2rem;
  @media screen and (min-width: 992px) {
    .header {
      flex-direction: row;
    }
  }
}

.dash-sub-section {
  border-top: none;
}

.dash-button {
  margin-left: 10px;
}

</style>
